module.exports = __webpack_public_path__ + "media/creativeMedia/panel04-7cd265d7.png";